import {useIsFetching} from "react-query";

const DefaultEmptyRenderer = () => (<td>Nothings here...</td>)

const DefaultRenderer = (item) => <td>{JSON.stringify(item)}</td>

const DefaultLoadingRenderer = () => (<td>Loading...</td>)

const TableRecords = ({
												header, records, itemRenderer, emptyRenderer, loadingRenderer, isLoading
											}) => {
	const isGlobalLoading = useIsFetching() > 0;
	const value = Array.isArray(records) ? records : (records == null ? [] : [records]);
	const isEmpty = value.length === 0;
	const _renderer = itemRenderer ?? DefaultRenderer;
	const _emptyRenderer = emptyRenderer ?? DefaultEmptyRenderer;
	const _loadingRenderer = loadingRenderer ?? DefaultLoadingRenderer;

	isLoading = isLoading ?? isGlobalLoading;

	return (
		<table>
			{header && (
				<thead>
					<tr>
						{header.map((h) => <th>{h}</th>)}
					</tr>
				</thead>
			)}
			<tbody>
			{isEmpty && (<tr>{_emptyRenderer()}</tr>)}
			{!isEmpty && value.map((item, index, list) => (<tr>{_renderer(item, index, list)}</tr>))}
			{isLoading && (<tr>{_loadingRenderer()}</tr>)}
			</tbody>
		</table>
	);
}

export default TableRecords;
